<template>
    <v-dialog
        v-model="display"
        persistent
        width="350"
        >
        <v-card>
            <v-card-title>{{ title }}</v-card-title>
            <v-card-text>{{ content }}</v-card-text>
            <v-card-actions>
                <v-btn text @click="submit">{{ $t("DECISION_APPROVE") }}</v-btn>
                <v-btn text @click="close">{{ $t("DECISION_REJECT") }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "DecisionDialog",
    data() {
        return {
            display: false,
            action: null,
            id: null,
            title: null,
            content: null
        }
    },
    methods: {
        open(params) {
            this.action = params.action;
            this.title = params.title;
            this.content = params.content;
            this.id = params.id;
            this.display = true;
        },
        close() {
            this.display = false;
            this.action = null;
            this.title = null;
            this.content = null;
            this.id = null;
        },
        submit() {
            this.$emit("submit", {action: this.action, id: this.id});
            this.close();
        }
    },
    created() {
        
    }
}
</script>